import { render, staticRenderFns } from "./HonorariosFiduciarios.vue?vue&type=template&id=0d23ec06&scoped=true"
import script from "./HonorariosFiduciarios.vue?vue&type=script&lang=js"
export * from "./HonorariosFiduciarios.vue?vue&type=script&lang=js"
import style0 from "./HonorariosFiduciarios.vue?vue&type=style&index=0&id=0d23ec06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d23ec06",
  null
  
)

export default component.exports